import { __decorate } from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import warning from '../../../lib/_util/warning';
import Base from './Base';
import { FormField } from '../field/FormField';
let Link = class Link extends FormField {
    renderWrapper() {
        const { ellipsis, rel, children, ...restProps } = this.props;
        warning(typeof ellipsis !== 'object', 'Typography.Link `ellipsis` only supports boolean value.');
        const mergedProps = {
            ...restProps,
            rel: rel === undefined && restProps.target === '_blank' ? 'noopener noreferrer' : rel,
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(Base, Object.assign({}, mergedProps, { ellipsis: !!ellipsis, component: "a" }), this.processRenderer(this.getValue()) || children),
            this.renderFloatLabel()));
    }
};
Link.displayName = 'Link';
Link.__PRO_TEXT = true;
Link.defaultProps = {
    ...FormField.defaultProps,
    suffixCls: 'link',
};
Link = __decorate([
    observer
], Link);
export default Link;
